import React from "react";
import TableRow from '../molecules/TableRow';
import imapIn from '../../images/imap_in.png';
import imapOut from '../../images/imap_out.png';
import popIn from '../../images/pop.png';
import popOut from '../../images/pop_out.png';

const SettingsTable = ({ settings = [] }) => {

  const getSettingValue = (name) => {
    const setting = settings.find((s) => s.name === name);
    return setting ? setting.value : '';
  };

  return (
    <div className="email-settings-container">

      <div className="header-container">
        <div className="header-wrapper">
          Your Email Settings
        </div>
      </div>

<div className="table-container">
  <table className="settings-table">
      <thead className="settings-table-header">
        <tr className="header-row">
          <th className="header">Option</th>
          <th className="header">Configuration</th>
        </tr>
      </thead>
      <tbody className="settings-table-body">
        {settings.map((setting, index) => (
            <TableRow key={index} setting={setting} />
          ))}
      </tbody>
    </table>
</div>

<div>
</div>

    <div className="outer-image-container">

      <div className="image-container">
        <div className="above-imap-header">
        There are two methods to configure your email settings. Choose either IMAP or POP configuration based on your requirements.<br />
        </div>
        <div className="email-protocols">
          <div className="protocol-description imap-description">
          • Use the IMAP email protocol to store a copy of your email messages on the server, allowing you to access them from multiple devices.
          </div>
          <div className="protocol-description pop-description">
          • Use the POP email protocol to download email messages from the server to your local device. By default, this method removes the emails from the server after downloading.
          </div>
          <div className="blog-link"><a href="https://register.lk/How_to_Configure_Register.lk_Emails_with_Outlook.php" target="_blank">Learn More</a></div>
        </div>
        <div className="imap-header">
          Configuration settings for Email Client using <span className="config-description">IMAP</span>
        </div>

        <div className="inner-image-wrapper">
        <div className="image-wrapper">
          <div className="image-title">
            IMAP Account Settings for Incoming Mail
          </div>
          <div className="image"><img src={imapIn} alt="Imap In" id="screenshot"/></div>
          <div className="overlay">
            <div className="imap-username">
              {getSettingValue('Username')}
            </div>
            <div className="imap-password">
              {getSettingValue('Password')}
            </div>
            <div className="imap-in">
              {getSettingValue('Your Host Name')}
            </div>
            <div className="port-in">
              {getSettingValue('IMAP Port')}
            </div>
          </div>
        </div>

        <div className="image-wrapper">
          <div className="image-title">
            IMAP Account Settings for Outgoing Mail
          </div>
          <div className="image"><img src={imapOut} alt="Imap Out" /></div>
          <div className="overlay">
            <div className="imap-out">
              {getSettingValue('Your Host Name')}
            </div>
            <div className="port-out">
              {getSettingValue('SMTP Port')}
            </div>
          </div>
        </div>
        </div>
        
      </div>

      <div className="image-container">
          <div className="imap-header">
          Configuration settings for Email Client using <span className="config-description">POP</span>
          </div>
        <div className="inner-image-wrapper">
        <div className="image-wrapper">
          <div className="image-title">
            POP Account Settings for Incoming Mail
          </div>
          <div className="image"><img src={popIn} alt="Pop In" /></div>
          <div className="overlay">
            <div className="pop-username">
              {getSettingValue('Username')}
            </div>
            <div className="pop-password">
              {getSettingValue('Password')}
            </div>
            <div className="pop-in">
              {getSettingValue('Your Host Name')}
            </div>
            <div className="port-995">
              {getSettingValue('POP3 Port')}
            </div>
          </div>
        </div>
        <div className="image-wrapper">
          <div className="image-title">
            POP Account Settings for Outgoing Mail
          </div>
          <div className="image"><img src={popOut} alt="Pop Out" /></div>
          <div className="overlay">
            <div className="pop-out">
              {getSettingValue('Your Host Name')}
            </div>
            <div className="port-out">
              {getSettingValue('SMTP Port')}
            </div>
          </div>
        </div>
        </div>
      </div>

    </div>
    </div>
  );
};

export default SettingsTable;